export default "__VITE_ASSET__DO$Op$lJ__"